<template>
  <v-btn
    v-if="totalPendentes > 0"
    icon
    style="box-shadow: none"
    class="text-none"
    aria-label="Justificativas de falta aguardando análise"
    @click="irParaListagem"
  >
    <v-badge :content="totalPendentes" color="error">
      <v-icon>mdi mdi-alpha-j-box-outline</v-icon>
    </v-badge>
  </v-btn>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ENotificacoesJustificativaFalta",
  computed: {
    ...mapGetters("JustificativaFalta", ["totalPendentes"]),
  },
  mounted() {
    this.carregarPendentes();
  },
  methods: {
    ...mapActions("JustificativaFalta", ["carregarPendentes"]),
    irParaListagem() {
      this.$router.push({ name: "justificativaFalta.index" });
    },
  },
};
</script>
